import { StyledFormsTemplatesFormLeavingEventInterceptor } from './FormsTemplatesFormLeavingEventInterceptor.styled';

type FormsTemplatesFormLeavingEventInterceptorProps = {
   readonly active: boolean;
   readonly children: JSX.Element;
};

export const FormsTemplatesFormLeavingEventInterceptor = (
   props: FormsTemplatesFormLeavingEventInterceptorProps
): JSX.Element => {
   return (
      <StyledFormsTemplatesFormLeavingEventInterceptor testId={'magistralDrugListItem'} active={props.active}>
         {props.children}
      </StyledFormsTemplatesFormLeavingEventInterceptor>
   );
};
